import { useProfile } from '@brg/auth';
import { FC } from 'react'
import {
    SuccessCloseButton,
    SuccessSummaryWrapper,
    SuccessTitle,
    SuccessWhiteButton,
    SuccessWrapper,
    SuccessPaymentText,
    SuccessInfoWrapper,
    SuccessButtonsBlock, SuccessPlaceWrapper
} from './styles'
import { useTranslation } from 'react-i18next';
import { OrderSummary } from "../../payment/OrderSummary/OrderSummary";
import { LinkTo } from "../../../../constants/linkTo";

export const BookPaymentSuccess: FC = (props: any) => {
    const profile = useProfile();
    const { t } = useTranslation()

    if (!profile) return <></>

    return (
        <SuccessPlaceWrapper>
            <SuccessWrapper isSuccess>
                <SuccessInfoWrapper>
                    <div style={{ width: "100%" }}>
                        <SuccessTitle isSuccess>{t('payment.success')}</SuccessTitle>
                        <SuccessPaymentText>{t("payment.payment_made")}</SuccessPaymentText>
                        <SuccessSummaryWrapper isSuccess>
                            <OrderSummary paymentSuccess />
                        </SuccessSummaryWrapper>
                    </div>
                    <SuccessButtonsBlock isSuccess >
                        <SuccessWhiteButton
                            whithoutBg
                            onClick={() => {
                                window.open(window.location.origin, "_self")
                            }}>
                            {t("project_edit.modal.success.go_to_main")}
                        </SuccessWhiteButton>
                        <SuccessCloseButton onClick={() => {
                            window.open(process.env.REACT_APP_URL_BOOKS_GALLLLERY + LinkTo.myBooks, "_self")
                        }}>
                            {t('project_edit.modal.success.go_to_my_books')}
                        </SuccessCloseButton>
                    </SuccessButtonsBlock>

                </SuccessInfoWrapper>
            </SuccessWrapper>
        </SuccessPlaceWrapper>
)}
import { useProfile } from '@brg/auth';
import { FC } from 'react'
import {
    SuccessCloseButton,
    SuccessSummaryWrapper,
    SuccessTitle,
    SuccessWhiteButton,
    SuccessWrapper,
    SuccessPaymentText,
    SuccessInfoWrapper,
    SuccessButtonsBlock, SuccessPlaceWrapper
} from './styles'
import { useTranslation } from 'react-i18next';
import { OrderSummary } from "../../payment/OrderSummary/OrderSummary";
import { LinkTo } from "../../../../constants/linkTo";

export const BookPaymentSuccess: FC = (props: any) => {
    const profile = useProfile();
    const { t } = useTranslation()

    if (!profile) return <></>

    return (
        <SuccessPlaceWrapper>
            <SuccessWrapper isSuccess>
                <SuccessInfoWrapper>
                    <div style={{ width: "100%" }}>
                        <SuccessTitle isSuccess>{t('payment.success')}</SuccessTitle>
                        <SuccessPaymentText>{t("payment.payment_made")}</SuccessPaymentText>
                        <SuccessSummaryWrapper isSuccess>
                            <OrderSummary paymentSuccess />
                        </SuccessSummaryWrapper>
                    </div>
                    <SuccessButtonsBlock isSuccess >
                        <SuccessWhiteButton
                            whithoutBg
                            onClick={() => {
                                window.open(window.location.origin, "_self")
                            }}>
                            {t("project_edit.modal.success.go_to_main")}
                        </SuccessWhiteButton>
                        <SuccessCloseButton onClick={() => {
                            window.open(process.env.REACT_APP_URL_BOOKS_GALLLLERY + LinkTo.myBooks, "_self")
                        }}>
                            {t('project_edit.modal.success.go_to_my_books')}
                        </SuccessCloseButton>
                    </SuccessButtonsBlock>

                </SuccessInfoWrapper>
            </SuccessWrapper>
        </SuccessPlaceWrapper>
)}
